/* eslint-disable */
import React, { useEffect, useState, useContext, useRef } from 'react';
import { toast } from 'react-toastify';
import { Input, Dropdown, Form, TextArea, Radio } from 'semantic-ui-react';
import {
  mdiClose,
  mdiContentCopy,
  mdiPlus,
  mdiChat,
  mdiFilePdfBox,
  mdiFileDocument,
} from '@mdi/js';
import FieldButton from './FieldButton';
import Modal from 'react-modal';
import CustomEditor from '../../components/CustomEditor/CustomEditor';
import Global from '../../clients/global';
import GBSwitch from '../../components/GBSwitch/GBSwitch';
import Icon from '@mdi/react';
import TextButton from '../../components/TextButton/TextButton';
import GBButton from '../../components/GBButton/GBButton';
import Spinner from '../../components/Spinner/Spinner';
import { uploadFiles } from '../../api/images';
import IconButton from '../Block/components/FilterData/IconButton';

const ActionFormatData = ({ localData, updateData, editMode, sourceNodes }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoading,setIsLoading]=useState(false);
  const [inputType, setInputType] = useState(localData.inputType ?? null);
  const [convertPDF, setConvertPDF] = useState(localData.convertPDF ?? false);
  const [availableFields, setAvailableFields] = useState([]);
  const [contentFields, setContentFields] = useState([]);
  const [rtfFields, setRTFFields] = useState(localData.rtfFields ?? []);
  const [content, setContent] = useState(localData.content ?? null);
  const [initContent, setInitContent] = useState(localData.content ?? '');
  const [pdfURL, setPdfURL] = useState(localData.pdfURL ?? null);
  const [docURL, setDocURL] = useState(localData.docURL ?? null);
  const [fileName, setFileName] =useState(localData.fileName ?? '');
  const fileInputRef = useRef(null);
  const [tableData, setTableData] = useState(
    localData?.tableData?.name.startsWith('api')
      ? localData.tableData
      : {
          name: `api_${localData.id}`,
          id: `api_${localData.id}`,
          tableinfo: { columns: [] },
        },
  );

  const hiddenInputStyle = {
    display: 'none',
  };

  const copyTextToClipboard = (text) => {
    // Create a temporary textarea element to hold the text
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Style the textarea to be invisible and move it off-screen
    textArea.style.position = 'fixed';
    textArea.style.top = '-9999px';
    textArea.style.left = '-9999px';

    // Append the textarea to the DOM
    document.body.appendChild(textArea);

    // Focus and select the text
    textArea.focus();
    textArea.select();

    let success = false;
    try {
      // Execute the copy command
      success = document.execCommand('copy');
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    // Clean up and remove the temporary textarea
    document.body.removeChild(textArea);
    return success;
  };

  const copyFieldsToClipBoard = () => {
     let modifiedText ='';
    if(inputType==='pdf') {
      modifiedText = contentFields.map(field => field.text).join('\n');
    } else if(inputType==='doc') {
       modifiedText = contentFields.map(field => `{${field.value.replace(/[^a-zA-Z0-9]+/g, '_')}}`).join('\n');
    }

    // --- CLIPBOARD ACTION ---
    // 4. Call the utility function to copy the final text.
    const wasSuccessful = copyTextToClipboard(modifiedText);
    if (wasSuccessful) {
      toast.info(<div style={{ margin: '5px' }}>Field tokans successfully copied to clipboard!</div>, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
        closeButton: true,
      });
    }
  };

  const getFile = () => {
    // 3. Programmatically click the hidden file input element
    //    The 'current' property points to the mounted <input> element
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const updateFileName =(val) =>{
    setFileName(val);
    localData.fileName =val;
    updateData(localData);
  }

  const handleDropdownChange = (e, data) => {
  // Find the full option object from the options array
  if(data.value=='') {
    return false
  }
  const selectedOption = data.options.find(option => option.value === data.value);

  // It's good practice to check if the option was found
  if (selectedOption) {
    // Now you can access the .text property
    const selectedText = selectedOption.text;
    updateFileName(fileName + selectedText);
  }
};

  const addRemoveField = (value) => {
    const idx = contentFields.findIndex((el) => el.value === value);
    const idx2 = availableFields.findIndex((el) => el.value === value);

    console.log(value);

    let tempInsert = structuredClone(contentFields);
    let tempAvailable = structuredClone(availableFields);

    if (idx === -1) {
      const fld = availableFields[idx2];
      fld.mappedValue = 'manual';
      tempInsert.push(fld);
      tempAvailable = tempAvailable.filter((itm) => itm.value !== value);
    } else {
      const fld = contentFields[idx];
      fld.mappedValue = 'manual';
      tempAvailable.push(fld);
      tempInsert = tempInsert.filter((itm) => itm.value !== value);
    }

    setContentFields(tempInsert);
    setAvailableFields(tempAvailable);

    localData.contentFields = tempInsert;
    updateData(localData);
  };

  // This function will be called when the user selects a file
  const handleFileChange = async (event) => {
    setIsLoading(true);
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      console.log('File selected:', selectedFile);
      const schema = `schema_${Global.zoneid}`;
      const urls = await uploadFiles(schema, [selectedFile], 'attachments');
      if (urls.length > 0) {
        if (inputType === 'pdf') {
          setPdfURL(urls[0].gcsurl);
          localData.pdfURL = urls[0].gcsurl;
        } else if (inputType === 'doc') {
          setDocURL(urls[0].gcsurl);
          localData.docURL = urls[0].gcsurl;
        }
        updateData(localData);
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAllFields();
  }, []);

  const updateInputType = (val) => {
    const copyTableData = structuredClone(tableData);
    setInputType(val);
    localData.inputType = val;
    tableData.name = 'Format Content';
    localData.tableData = tableData;

    if (val === 'rtf') {
      copyTableData.tableinfo.columns = [
        {
          data: 'rtf',
          header: 'rtf',
          uitype: 13,
          path: 'rtf',
        },
      ];
    } else {
      setConvertPDF(false);
      copyTableData.tableinfo.columns = [
        {
          data: val,
          header: val,
          uitype: 4,
          path: val,
        },
      ];
    }

    console.log('updating data');
    setTableData(copyTableData);
    localData.tableData = copyTableData;
    updateData(localData);
  };

  const updateConvertPDF = (val) => {
    setConvertPDF(val);
    const copyTableData = structuredClone(tableData);
    if (val === true) {
      copyTableData.tableinfo.columns.push({
        data: 'pdf',
        header: 'pdf',
        uitype: 4,
        path: 'pdf',
      });
    } else {
      copyTableData.tableinfo.columns = [
        {
          data: 'rtf',
          header: 'rtf',
          uitype: 13,
          path: 'rtf',
        },
      ];
    }

    localData.tableData = copyTableData;
    localData.convertPDF = val;
    updateData(localData);
  };

  const updateContent = () => {
    setInitContent(content);
    localData.content = content;
    updateData(localData);
    setModalIsOpen(false);
  };

  const deletePDF = () => {
    setPdfURL(null);
    delete localData.pdfURL;
    updateData(localData);
  };

  const deleteDoc = () => {
    setDocURL(null);
    delete localData.docURL;
    updateData(localData);
  };

  const getAllFields = () => {
    if (localData.contentFields !== undefined) {
      setContentFields(localData.contentFields);
    }

    const allOptions = [{ key: '0', value: '', text: 'Choose field' }];

    sourceNodes.map((node) => {
      !node.data.insertMultiple &&
        node.data?.tableData?.tableinfo?.columns.map((col) => {
          const idx = allOptions.findIndex(
            (itm) => itm.key === `${node.data.tableData.id}||${col.data}`,
          );
          if (idx === -1) {
            allOptions.push({
              key: `${node.data.tableData.name}::${node.data.tableData.id}||${col.header}`,
              value: `${node.data.tableData.name}::${node.data.tableData.id}||${col.header}`,
              text: `{{${node.data.tableData.name}::${node.data.tableData.id}||${col.header}}}`,
              //         //   text: `${node.data.tableData.name}||${col.header}`,
            });
          }
        });
    });

    setAvailableFields(allOptions);
  };

  return (
    <div
      style={{
        position: 'relative',
        backgroundColor: '#fff',
        minHeight: '300px',
        border: '1px solid #0D99FF',
        borderRadius: '5px',
        padding: '20px',
        paddingBottom: '20px',
      }}
    >
      <div style={{ marginBottom: '10px', fontSize: '20px', fontWeight: 'bold' }}>
        Action details
      </div>
      <div>
        <div>
          <div style={{ marginBottom: '5px' }}>Generate a</div>
          <Form>
            <Form.Field style={{ marginBottom: '5px' }}>
              <Radio
                label="Rich text (RTF)"
                name="radioGroup1"
                value="rtf"
                checked={inputType === 'rtf'}
                onChange={(e, data) => updateInputType(data.value)}
              />
            </Form.Field>
            {inputType === 'rtf' ? (
              <div style={{ marginLeft: '30px', marginBottom: '10px' }}>
                <GBSwitch
                  text="Convert to PDF"
                  Action={updateConvertPDF}
                  isChecked={convertPDF}
                  ActionValue={!convertPDF}
                />
              </div>
            ) : null}

            <Form.Field style={{ marginBottom: '10px' }}>
              <Radio
                label="PDF Document"
                name="radioGroup1"
                value="pdf"
                checked={inputType === 'pdf'}
                onChange={(e, data) => updateInputType(data.value)}
              />
            </Form.Field>
            <Form.Field style={{ marginBottom: '10px' }}>
              <Radio
                label="Word template"
                name="radioGroup1"
                value="doc"
                checked={inputType === 'doc'}
                onChange={(e, data) => updateInputType(data.value)}
              />
            </Form.Field>
          </Form>
        </div>
        {inputType === 'rtf' ? (
          <div>
            <GBButton
              text="Format content"
              fontSize="15px"
              iconColor="white"
              iconHoverColor="white"
              borderRadius="10px"
              Action={() => setModalIsOpen(true)}
              ActionValue={'trigger'}
              textColor="white"
              width="200px"
              padding="10px"
              fontWeight="normal"
              color="#0D99FF"
              textHoverColor="white"
              hoverBackgroundColor={'#0D99FF80'}
            />
          </div>
        ) : null}

        {inputType === 'pdf' && pdfURL === null  && !isLoading ? (
          <div>
            <GBButton
              text="Upload PDF"
              fontSize="15px"
              iconColor="white"
              iconHoverColor="white"
              borderRadius="10px"
              Action={getFile}
              ActionValue={'trigger'}
              textColor="white"
              width="200px"
              padding="10px"
              fontWeight="normal"
              color="#0D99FF"
              textHoverColor="white"
              hoverBackgroundColor={'#0D99FF80'}
            />
          </div>
        ) : null}

        {inputType === 'doc' && docURL === null && !isLoading ? (
          <div>
            <GBButton
              text="Upload docx"
              fontSize="15px"
              iconColor="white"
              iconHoverColor="white"
              borderRadius="10px"
              Action={getFile}
              ActionValue={'trigger'}
              textColor="white"
              width="200px"
              padding="10px"
              fontWeight="normal"
              color="#0D99FF"
              textHoverColor="white"
              hoverBackgroundColor={'#0D99FF80'}
            />
          </div>
        ) : null}

        {isLoading ? (
          <Spinner color="#0D99FF" />
        ):null}

        {pdfURL !== null && inputType === 'pdf' ? (
          <div
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div>
              <a href={pdfURL} target="newWindow">
                <Icon path={mdiFilePdfBox} size={'50px'} />
              </a>
            </div>
            <div style={{ position: 'absolute', top: -5, left: 45 }}>
              <IconButton
                color="red"
                hoverColor="white"
                hoverBackgroundColor="#F6685E"
                icon={mdiClose}
                Action={deletePDF}
              />
            </div>
          </div>
        ) : null}

        {docURL !== null && inputType === 'doc' ? (
          <div
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div>
              <a href={docURL} target="newWindow">
                <Icon path={mdiFileDocument} size={'50px'} />
              </a>
            </div>
            <div style={{ position: 'absolute', top: -5, left: 45 }}>
              <IconButton
                color="red"
                hoverColor="white"
                hoverBackgroundColor="#F6685E"
                icon={mdiClose}
                Action={deleteDoc}
              />
            </div>
          </div>
        ) : null}

        {inputType !== 'rtf' ? (
          <div style={{ marginTop: '20px' }}>
            <FieldButton options={availableFields} addRemoveField={addRemoveField} icon={mdiPlus} />
            <div style={{ marginBottom: '10px' }} />
            {contentFields.length > 0
              ? contentFields.map((fld) => (
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div style={{ marginRight: '5px' }}>{fld.text}</div>
                    <div>
                      <IconButton
                        color="red"
                        hoverColor="white"
                        hoverBackgroundColor="#F6685E"
                        icon={mdiClose}
                        Action={addRemoveField}
                        ActionValue={fld.value}
                      />
                    </div>
                  </div>
                ))
              : null}
            <div style={{marginTop:'5px'}}>
              <TextButton icon={mdiContentCopy} iconPosition='right' textColor='black' text="Copy field tokens" Action={copyFieldsToClipBoard} />
            </div>
          </div>
        ) : null}

        {inputType !=='rtf' || convertPDF ? (
          <div style={{marginTop:'15px'}}>
            <div style={{fontWeight:'bold'}}>Document title ({convertPDF || inputType==='pdf' ? '.PDF':'.DOCX'})</div>
            <div style={{marginTop:'5px',marginBottom:'5px'}}>
              <Dropdown clearable selection fluid options={availableFields} onChange={handleDropdownChange} /></div>
            <Input fluid value={fileName} onChange={(e,data)=>updateFileName(data.value)} /> 
        </div>): null}

        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={hiddenInputStyle}
          accept={inputType === 'pdf' ? '.pdf,application/pdf' : '.docx'}
        />
      </div>

      <Modal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        style={{
          overlay: {
            position: 'fixed',
            zIndex: 100,
            top: 50,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0)',
          },
          content: {
            border: `.3px solid #0D99FF`,
            margin: '20px',
            background: '#fff',
            overflow: 'auto',
            zIndex: 10,
            WebkitOverflowScrolling: 'touch',
            borderRadius: '10px',
            outline: 'none',
            padding: '20px',
          },
        }}
        contentLabel="Content Modal"
      >
        <CustomEditor
          initValue={initContent}
          updateContent={setContent}
          height={300}
          callingComponent="EmailControl"
          tokens={availableFields}
        />
        <div
          style={{
            marginRight: '50px',
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <TextButton
            text="Cancel"
            Action={() => setModalIsOpen(false)}
            textColor="black"
            // icon={mdiClose}
            hoverColor="#00000080"
          />
          <div style={{ width: '10px' }} />
          <GBButton
            padding="10px"
            color={'#0D99FF'}
            width="75px"
            text="Save"
            Action={updateContent}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ActionFormatData;
